import React from 'react';
import { financialCalculators_En } from '../ConstantsEN';
import SharedHelmet from '../Helmet';
const TITLE = 'Financial Calculators - Free Calculators for Loans, Investments, and Financial Operations';
const DESCRIPTION = 'Explore a collection of free financial calculators, including loan calculators, investment calculators, and financial operations calculators.';
const KEYWORDS = 'Financial calculators, free calculators, loan calculator, investment calculator, financial operations calculator';
const NOTE = 'If you know or want to add other calculators, please contact us via email at info@do-calculate.com. We will be happy to add them! :)';
const OG_URL = 'https://do-calculate.com/en/financial-calculators';
function CalculatorsList() {
    return (
        <div className="ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Calculator</th>
                        <th >Description</th>
                    </tr>
                </thead>
                <tbody>
                    {financialCalculators_En.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
